var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppLightroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#001E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5703 14.4297H18.4526V33.3381H29.8496V39.2214H11.5703V14.4297ZM40.0991 19.573C41.6162 19.573 42.8374 19.7581 43.3926 19.9431V24.9753C42.9482 24.8645 42.0977 24.7905 41.3945 24.7905C40.0254 24.7905 39.2481 24.9014 38.5449 25.1604V39.2214H32.0693V21.2012C34.4004 20.1651 36.7319 19.573 40.0991 19.573Z",
    fill: "#31A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppLightroom);
export default __webpack_public_path__ + "static/media/B_app_Lightroom.301337c1b617fed35d51c1e904d6cc1e.svg";
export { ForwardRef as ReactComponent };